
<script>
import BarList from '../components/bar-list.vue'
import { SysVars } from '../main';
import vcaixaForm from './vcaixa-form.vue'
export default {
  components: { vcaixaForm, BarList },
    data(){
        return {
            showForm: false, //exibe a tela de manutencao,
            vcaixa: '',
            crud: '',
            filter: '',
            offset:'',
            codvcaixa: 0,
            metadata: this.$store.getters.getEntities.metadata,
        }
    },
    computed:{
        vcaixaList(){
            return this.$store.getters.getVCaixaList
        },
        nextPage(){
            return this.$store.getters.getNextPage
        }
    },
    methods:{
        handleEdit(cod, view){
            if(view)
                this.crud = SysVars.crudView
            else
                this.crud = SysVars.crudU

            this.codvcaixa = cod
            this.showForm = true
        },
        handleNew(){
            this.crud = SysVars.crudI
            this.codvcaixa = ''
            this.showForm = true
        },
         handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },
        loadData(){
            this.$store.dispatch('loadVCaixa', { filter:this.filter, page: this.nexPage} )
            this.offset = ''
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },
        search(value){
            //efetua a pesquisa
            let valueU = value.toUpperCase()

            this.filter = '{"$or":[{"codvcaixa":{"$like":"%25' + valueU + '%25"}},{"descricao":{"$like":"%25' + valueU + '%25"}}]}'
            this.loadData()
        },
        closeForm(){
            this.showForm = false
            this.loadData()
        },
        stcaixa(st){
            let descricao =  ''
            this.metadata.vcaixa.stcaixa.options.find(e=> {if(e.id == st){
                descricao = e.text
            }})
            return descricao
        },
    },
    created() {
        this.showForm = false
        this.loadData()
    },
}
</script>

<template>
    <div>
        <div id="list" v-show="!showForm" ><!--Toltip block-->
            <bar-list
            :refresh-button="true"
            :new-button="true"
            :pdf-button="false"
            :xls-button="false"
            single-entity="Caixa PDV"
            plural-entity="Caixas PDV"
            @search="search"
            @new="handleNew"
            @refresh="loadData"
            title-search="Pesquise pela descrição"
            >
            </bar-list>
            <br>
            <div class="default-container">
            <alert type="norecord" v-if="vcaixaList.length == 0"></alert>
                <div class="mainbox"  v-for="vcaixa in vcaixaList" :key="vcaixa.codvcaixa">
                <div class="mark-green"></div>
                <div class="box">
                    <div class="row align-items-center">
                        <div class="col-md-6 col-8 d-flex flex-column">
                            <span class="lbl-list">Descrição</span>
                            <span class="data-list">{{ vcaixa.descricao }}</span>
                        </div>
                        <div class="col-md-2 col-2">
                            <span class="lbl-list">Caixa Ativo?</span> <br>
                            <span class="data-list">{{stcaixa(vcaixa.stcaixa)}}</span>
                        </div>
                        <div class="col-md-4 col-12">
                            <bar-grid
                            :options="{barDefault: true, btnView: true, btnEdit: true}"
                            :moreActions="[]"
                            @edit="handleEdit(vcaixa.codvcaixa)"
                            @view="handleEdit(vcaixa.codvcaixa, true)">
                            </bar-grid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <vcaixaForm v-if="showForm" :index="this.codvcaixa" :crud="this.crud" @closeform="closeForm"></vcaixaForm>
  </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms/vcaixa-list.vue